
import React, { Fragment } from "react"
import InputStep from "./InputStep"
import SendStep from "./SendStep"
import EndStep from "./EndStep"
import { datas } from "./datas"
import './contact.css';

const sendDatasUrl =  datas['url envoi formulaire']

class Contact extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
			nom: '',
			prenom: '',
			email: '',
			telephone: '',
			message: '',
			error: '',
			end: false,
			input: true,
			send: false
		}
    }

    handleChange = (event) => {
		let name = event.target.name
		let value = event.target.value
		this.setState({...this.state, [name]: value})
	}

    handleClick = (event) => {
		let error = ''
		if(!this.state.email.match('[a-z0-9]+@[a-z]+.[a-z]{2,3}')){
			error = 'Adresse email incorrecte'	
		}
		if(this.state.nom === '' ||
		   this.state.prenom === '' ||
		   this.state.email === '' ||
		   this.state.message === ''){
			error = 'Champs obligatoire(s) non renseigné(s)'
		}		   		
		if(error===''){
			this.sendDatas(this.state)
			this.setState({...this.state, 'send': true})
		}
		else{
			this.setState({...this.state, 'error': error})
		}
	}
    
    sendDatas = async(datas) => {
		const options = {   
            method  : 'POST',
            body : JSON.stringify(datas)
        }
        fetch(sendDatasUrl, options)
        .then((response) => { 
            return response.json()
        })
        .then((json) => {			
			if(json.statut==='success'){
				setTimeout(() => {
					this.setState({...this.state, 'input': false, 'send': false, 'end': true})
				}, 2000)
			} 
			else{
				if(json.statut==='error'){
					console.log('error')
				}
				else{
				}
			} 
        })
		.catch((error) => {
			console.log(error)
		})
	}	

    render (){
        return (
            <Fragment>
                {this.state.input && <InputStep state={this.state} handleChange={this.handleChange} handleClick={this.handleClick} />}
                {this.state.send && <SendStep />}
                {this.state.end && <EndStep />}
            </Fragment>
        )
    }    
}

export default Contact